import { useEffect, useState } from 'react';

/** An object URL for the blob, revoked when the blob changes or the component unmounts; null until created. */
export const useObjectUrl = (blob: Blob | null | undefined) => {
    const [url, setUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!blob) {
            setUrl(null);
            return;
        }
        const objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [blob]);

    return url;
};
